import { Box, CircularProgress, Grid } from "@mui/material";
import { useAppSelector } from "../../../../Redux/store";
import TalentSearch from "../../../../Shared Components/TalentSearch";
import { Recepient } from "../Recepient";
import { Talent } from "../../../../Types/Talent";
import { ComposeMessageTalent } from "../../../../Types/Client";
import { useUser } from "../../../../Hooks/useUser";

interface IProps {
    selectedRecepient: ComposeMessageTalent | undefined;
    existingConversations: (string | undefined)[];
    hiredTalents: ComposeMessageTalent[] | undefined; 
    handleCheck: (user: any) => void;
}

const ComposeMessageTalentSearch = ({ selectedRecepient, existingConversations, hiredTalents, handleCheck}:IProps) => {
    /* ******************** Hooks ******************** */
    const { hasPremium } = useUser();
    /* ******************** Variables ******************** */   
    const {Result, ResultsLoading} = useAppSelector( state => state.TalentSearch);
    /* ******************** Functions ******************** */
    const filteredResults = Result.filter( r => !existingConversations.some( e => e === r.locator) && !(hiredTalents && hiredTalents.some(h => h.locator === r.locator)));
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    // TODO: Show prompt to upgrade if not has premium
    // Disable TalentSearch
    return (
        <>
            <TalentSearch {...{hasPremium}} />
            {     
                ResultsLoading  ? 
                <Box
                    display={'flex'}
                    flexDirection={'row'}
                    justifyContent={'center'} 
                >
                    <CircularProgress/>
                </Box>
                :    
                <Grid display={'flex'} flexDirection={'column'} gap={2} maxHeight={'154px'} overflow={'auto'}>
                    {
                        filteredResults.map( (j, idx) => (                                    
                            <Recepient 
                                key={idx}
                                user={j} 
                                selectedRecepient={selectedRecepient} 
                                handleCheck={handleCheck}
                            />
                        ))
                    }
                </Grid>
            }      
        </>
    )
}

export default ComposeMessageTalentSearch